export var UserRoles;
(function (UserRoles) {
    UserRoles["Owner"] = "Owner";
    UserRoles["Donor"] = "Donor";
    UserRoles["Member"] = "Member";
})(UserRoles || (UserRoles = {}));
/**
 * @deprecated use UserGeneralPermissions or UserFormPermissions
 */
export var UserPermissions;
(function (UserPermissions) {
    UserPermissions["Donation"] = "Donation";
    UserPermissions["Ticketing"] = "Ticketing";
    UserPermissions["Contacts"] = "Contacts";
    UserPermissions["UserManagement"] = "UserManagement";
    UserPermissions["Receipt"] = "Receipt";
    UserPermissions["Bank"] = "Bank";
    UserPermissions["TapToPay"] = "TapToPay";
})(UserPermissions || (UserPermissions = {}));
export var UserScope;
(function (UserScope) {
    UserScope["Organization"] = "Organization";
    UserScope["Donor"] = "Donor";
})(UserScope || (UserScope = {}));
export var UserGeneralPermissions;
(function (UserGeneralPermissions) {
    UserGeneralPermissions["Contacts"] = "Contacts";
    UserGeneralPermissions["UserManagement"] = "UserManagement";
    UserGeneralPermissions["Bank"] = "Bank";
    UserGeneralPermissions["TapToPay"] = "TapToPay";
})(UserGeneralPermissions || (UserGeneralPermissions = {}));
export var UserFormPermissions;
(function (UserFormPermissions) {
    UserFormPermissions["ManagePayments"] = "ManagePayments";
    UserFormPermissions["EditForm"] = "EditForm";
    UserFormPermissions["Receipt"] = "Receipt";
})(UserFormPermissions || (UserFormPermissions = {}));
